import { Principal, Sender } from '../../../data/types.generated';
import { getDisplayName } from '../../../utilities/MapESignModel';

/**
 * Converts type Sender to Principal.
 *
 * @param sender Sender.
 * @returns a Principal.
 */
export const convertESignSenderToPrincipal = (sender: Sender): Principal | null => {
    if (!sender) {
        return null;
    }

    return {
        id: sender.id ?? (sender.userId || ''),
        displayName: getDisplayName(sender.fullName, sender.email) ?? '',
    };
};
